import { type Theme } from "@mui/material";

export function getStrongText(theme: Theme) {
  return theme.palette.base?.strong ?? theme.palette.text.primary;
}

export function getMutedText(theme: Theme) {
  return theme.palette.base?.muted ?? theme.palette.text.secondary;
}

export function getBorderBase(theme: Theme) {
  return theme.palette.border?.base ?? theme.palette.divider;
}

export function getBackgroundBase(theme: Theme) {
  return theme.palette.background.base ?? theme.palette.background.default;
}

export function getBackgroundStandout(theme: Theme) {
  return theme.palette.background.standout ?? theme.palette.background.paper;
}

export function getBackgroundMuted(theme: Theme) {
  return theme.palette.background.muted ?? theme.palette.action.hover;
}
